<template>
    <el-dialog custom-class="cancel_coll_dialog" :model-value="show" title="取消收藏" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-shoucang1"></i></div>
            <h1>取消收藏</h1>
            <h2>取消收藏后，文章将会移出【收藏夹】</h2>
            <div class="btn_box" v-loading="loading">
                <button @click="handleClose">我再想想</button>
                <button @click="submit">取消收藏</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref } from "vue";
import { Close } from "@element-plus/icons-vue";
import { apiFavoriteArticleRemove } from "@/request/api";

const props = defineProps({
    show: { type: Boolean, default: false },
    row: { type: Object, default: {} },
});
const emits = defineEmits(["close", "success"]);

const loading = ref(false);

async function submit() {
    loading.value = true;
    try {
        const { code } = await apiFavoriteArticleRemove({ articleId: props.row.articleId, id: props.row.favoriteId });
        if (code !== "0") return;
        emits("success", { articleId: props.row.articleId });
        handleClose();
    } finally {
        loading.value = false;
    }
}
// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    emits("close");
}
</script>

<style lang="scss">
.cancel_coll_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            span {
                color: #2a2a2a;
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
